import * as fuzz from 'fuzzball';

const getSpanText = (data) => {
  if (typeof data !== 'object' || !data) {
    return '';
  }

  return data.text.toLowerCase();
};

const getPossibleMatches = (searchData, searchText) => {
  const results = [];
  const preprocessedSearchText = fuzz.full_process(searchText);
  for (const [, groupData] of Object.entries(searchData)) {
    for (const [, data] of groupData.entries()) {
      const spanText = getSpanText(data);
      const score = fuzz.partial_token_similarity_sort_ratio(preprocessedSearchText, spanText);
      let scoreAddition = 0;

      if (spanText.length > searchText.length) {
        scoreAddition = searchText.length / spanText.length;
      }

      results.push({
        score: score + scoreAddition,
        data
      });
    }
  }

  return results.sort((a, b) => b.score - a.score);
}

// MAIN
const getTextToHighlight = (searchData, searchText) => {
  try {
    const possibleMatches = getPossibleMatches(searchData, searchText);
    if (!possibleMatches.length) return [];
    const rowIds = [possibleMatches[0].data.rowId];

    for (let i = 1; i < possibleMatches.length; i++) {
      const match = possibleMatches[i];

      if (match.score === possibleMatches[0].score) {
        rowIds.push(match.data.rowId);
      } else {
        break;
      }
    }

    return rowIds;
  } catch (error) {
    console.error('[getTextToHighlight] error: ', error);
    return [];
  }
};

export { getTextToHighlight };
